module.exports = __webpack_public_path__ + "static/media/foul-play-feature-banner-sm@1x.a1cba11d.jpg";